// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Children_form__\\+SosP {
  margin-bottom: 50px;
}
.Children_form__\\+SosP:last-of-type {
  margin-bottom: 0;
}

.Children_intro__Vrwrp {
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: #00007a;
}

.Children_subtitle__TGOS3 {
  margin-bottom: 16px;
  font-weight: 500;
  font-size: 20px;
  line-height: 36px;
  color: #00007a;
  margin-top: 30px;
}
.Children_subtitle__TGOS3:first-of-type {
  margin: 0;
}
.Children_subtitle__TGOS3 span {
  font-size: 14px;
  vertical-align: middle;
  color: #0000c9;
  cursor: pointer;
}

.Children_footer__Fj8qb {
  width: 100%;
  text-align: center;
}
.Children_footer__Fj8qb p {
  text-align: left;
}
.Children_footer__Fj8qb button {
  display: inline-block;
  margin: 50px 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/Freemium/Children/Children.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;AAIF;AAHE;EACE,gBAAA;AAKJ;;AADA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCPS;ADWX;;AADA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCfS;EDgBT,gBAAA;AAIF;AAFE;EACE,SAAA;AAIJ;AADE;EACE,eAAA;EACA,sBAAA;EACA,cC3BO;ED4BP,eAAA;AAGJ;;AACA;EACE,WAAA;EACA,kBAAA;AAEF;AAAE;EACE,gBAAA;AAEJ;AACE;EACE,qBAAA;EACA,gBAAA;AACJ","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.form{\n  margin-bottom: 50px;\n  &:last-of-type{\n    margin-bottom: 0;\n  }\n}\n\n.intro{\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  color: colors.$primary8;\n}\n\n.subtitle {\n  margin-bottom: 16px;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 36px;\n  color: colors.$primary8;\n  margin-top: 30px;\n\n  &:first-of-type{\n    margin: 0;\n  }\n\n  span{\n    font-size: 14px;\n    vertical-align: middle;\n    color: colors.$primary6;\n    cursor: pointer;\n  }\n}\n\n.footer{\n  width: 100%;\n  text-align: center;\n\n  p{\n    text-align: left;\n  }\n\n  button{\n    display: inline-block;\n    margin: 50px 6px;\n  }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"form": `Children_form__+SosP`,
	"intro": `Children_intro__Vrwrp`,
	"subtitle": `Children_subtitle__TGOS3`,
	"footer": `Children_footer__Fj8qb`
};
export default ___CSS_LOADER_EXPORT___;
